/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import { useSelector } from "react-redux";
import BASESearch from "../../../@BASE/core/BASESearch";
import { selectFlatNavigation } from "../../store/BASE/navigationSlice";

function NavigationSearch(props) {
  const { variant, className } = props;
  const navigation = useSelector(selectFlatNavigation);

  return (
    <BASESearch
      className={className}
      variant={variant}
      navigation={navigation}
    />
  );
}

export default NavigationSearch;
